// for add employee state
export const ADD_COMPANY_PROFILE_DATA = "add_company_profile_data";
